<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center">
                <div class="py-3 mr-2">
                    <a href="#!"
                       class="qf-tab-label text-uppercase px-2" :class="{'qf-active-tab' :activeTab === 'bpc'}"
                       @click.prevent="changeTab('bpc')">{{$ml.get('Bulgarian_Patent_Company')}}</a>
                </div>
                <div class="py-3 mr-2">
                    <a href="#!"
                       class="qf-tab-label text-uppercase px-2" :class="{'qf-active-tab' :activeTab === 'oami'}"
                       @click.prevent="changeTab('oami')">{{$ml.get('OAMI')}}</a>
                </div>
                <div class="py-3 mr-2">
                    <a href="#!"
                       class="qf-tab-label text-uppercase px-2" :class="{'qf-active-tab' :activeTab === 'wipo'}"
                       @click.prevent="changeTab('wipo')">{{$ml.get('WIPO')}}</a>
                </div>
                <div class="flex-grow-1 d-flex justify-content-end align-items-center">
                    <div class="mr-2">
                        <a href="#!" @click.prevent="searchOpen = !searchOpen" v-if="!searchOpen"><font-awesome-icon icon="search"/>&nbsp;&nbsp;{{$ml.get('Search')}}</a>
                        <input type="text" class="form-control" name="search" :placeholder="$ml.get('Search')" v-else v-click-outside="initiateSearch">
                    </div>
                    <div>
                        <router-link to="/dashboard/add-brand" class="btn btn-outline-dark text-uppercase btn-sm">
                            <font-awesome-icon icon="plus"/>&nbsp;&nbsp;{{$ml.get('add')}}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 pt-3">
            <div class="table-responsive">
                <table class="table qf-table text-center">
                    <thead>
                    <tr>
                        <th><a href="">{{$ml.get('Name')}}&nbsp;<font-awesome-icon icon="chevron-down" class="animate-all"/></a></th>
                        <th><a href="">{{$ml.get('Size')}}&nbsp;<font-awesome-icon icon="chevron-down" class="animate-all"/></a></th>
                        <th><a href="">{{$ml.get('Uploaded_By')}}&nbsp;<font-awesome-icon icon="chevron-down" class="animate-all"/></a></th>
                        <th><a href="">{{$ml.get('Status')}}&nbsp;<font-awesome-icon icon="chevron-down" class="animate-all"/></a></th>
                        <th><a href="">{{$ml.get('Date')}}&nbsp;<font-awesome-icon icon="chevron-down" class="animate-all"/></a></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="py-3">neshto.zip</td>
                        <td class="py-3">12 MB</td>
                        <td class="py-3">S. Neshtov</td>
                        <td class="py-3">IMPORTED</td>
                        <td class="py-3">6.16.2016</td>
                    </tr>
                    <tr>
                        <td class="py-3">neshto.zip</td>
                        <td class="py-3">12 MB</td>
                        <td class="py-3">S. Neshtov</td>
                        <td class="py-3">IMPORTED</td>
                        <td class="py-3">6.16.2016</td>
                    </tr>
                    <tr>
                        <td class="py-3">neshto.zip</td>
                        <td class="py-3">12 MB</td>
                        <td class="py-3">S. Neshtov</td>
                        <td class="py-3">IMPORTED</td>
                        <td class="py-3">6.16.2016</td>
                    </tr>
                    </tbody>

                </table>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "UploadTrademark",
        data () {
            return {
                activeTab: 'bpc',
                searchOpen: false
            }
        },
        methods: {
            changeTab(tabName) {
                this.activeTab = tabName;
            },
            initiateSearch(){
                if(this.searchOpen){
                    this.searchOpen = !this.searchOpen
                }
            }
        }
    }
</script>

<style scoped>

</style>